const routes = [
	{
		path: "/",
		component: () => import("../views/dangky/screen/HomePage.vue"),
	},
	{
		path: "/DotDangKy",
		name: "dot-dang-ky",
		component: () => import("../views/dangky/screen/HomePage.vue"),
	},
	{
		path: "/DangKy/:dotDangKyId",
		name: "dang-ky-hoc-ba",
		component: () => import("../views/dangky/screen/DangKy.vue"),
	},
	{
		path: "/DieuChinhNV",
		name: "dieu-chinh-nguyen-vong",
		component: () => import("../views/chinhsua/screen/DieuChinh.vue"),
	},
	{
		path: "/LienHe",
		name: "lien-he",
		component: () => import("../views/lienhe/LienHe.vue"),
	},
	// {
	// 	path: "/NhapHoc",
	// 	name: "nhap-hoc",
	// 	component: () => import("../views/nhaphoc/screen/DanhSachLoaiDot.vue"),
	// },
	// {
	// 	path: "/NhapHoc/TrungTuyenHocBa/:id",
	// 	name: "nhap-hoc-trung-tuyen-hoc-ba",
	// 	component: () => import("../views/nhaphoc/screen/ThongTin.vue"),
	// },
	// {
	// 	path: "/NhapHoc/TrungTuyenTHPT/:id",
	// 	name: "nhap-hoc-trung-tuyen-thpt",
	// 	component: () => import("../views/nhaphoc/screen/ThongTin.vue"),
	// },
	{
		path: "/TraCuu",
		name: "tra-cuu",
		component: () => import("../views/tracuu/TraCuu.vue"),
	},
	{
		path: "*",
		redirect: "/DotDangKy",
	},
	{
		path: "/ThongBao",
		component: () => import("../components/thongtindangky/screen/ThongBaoThanhCong.vue")
	}
];
export default routes;